import { NgModule } from '@angular/core';

import { ProductsService } from './application/services/products.service';
import { ApiProductsService } from './infrastructure/api/api-products.service';

@NgModule({
    providers: [
        ApiProductsService,
        ProductsService,
    ],
})

export class ProductsFeatureModule {}
